import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "action-list" }
const _hoisted_8 = {
  key: 0,
  class: "button-group"
}
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "dialog-footer" }

import { useRouter } from 'vue-router'
import { getCurrentInstance, reactive, ref, onActivated,watch,onBeforeUnmount } from 'vue'
import { BrandM } from '@/models/brand'
import { getBrandListApi } from '@/apis/brand'
import { getGroupMsgList,batchSendMsgsInfo } from '@/apis/notice'
import Pagination from '@/components/Pagination.vue'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'
import SelectBrand from '@/components/SelectBrand.vue'
import { SCOPE } from 'element-plus'

// 每行数据模型
interface RowI {
    title?: string, // 标题
    desc: string, // 内容
    msg_type: string, // 类型
    attach_url?: object, // 附件
    no_brand_ids: string, // 品牌id
    messageList:Object
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupMsgList',
  setup(__props) {

const activeIndex = ref(0)
const {proxy} = getCurrentInstance() as any
const router = useRouter()

const filters = reactive({
    no_brand_ids: '',
    send_status:'',
    msg_type: '',
    start_date: '',
    end_date: '',
    page: 1,
    page_size: 10,
})
const infos = reactive({
    page: 1,
    page_size: 10,
    msginfo: [],
    total:0,
})
const getButtonLabel = (msgType) => {
      switch(msgType) {
        case 1: return '邮件';
        case 2: return '短信';
        case 3: return '公众号';
        default: return '未知类型';
      }
 }
// 品牌列表
const brandList = ref<BrandM[]>([])
const onGetBrandList = async () => {
    const {code, data, msg} = await getBrandListApi() as any
    if (code != 200) return proxy.$message({ type: 'error', message: msg })
    brandList.value = data
}

// 搜索
const onSearch = () => {
    filters.page = 1
    getList()
}

// 表格数据
const msgList = ref([])
const total = ref(0)
const timer = ref(null);
const refreshCount = ref(0); // 记录刷新次数

const getList = async () => {
    const {code, data, msg} = await getGroupMsgList(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    msgList.value = data.data
    total.value = data.total
    // 检查是否需要继续刷新
    if (!checkSendStatus() && timer.value) {
      clearInterval(timer.value);
      timer.value = null;
      refreshCount.value = 0;
    }
};
const checkSendStatus = () => {
  return msgList.value.some(item => item.send_status === 0);
};

watch( () => msgList.value, (newList, oldList) => {
    if (checkSendStatus()) {
      startRefreshTimer();
    } else if (timer) {
      clearInterval(timer.value);
      timer.value = null;
      refreshCount.value = 0;
    }
  },
  { deep: true }
);

const startRefreshTimer = () => {
  if (timer.value) clearInterval(timer.value);

  timer.value = setInterval(() => {
    getList();
    refreshCount.value++;
    if (refreshCount.value >= 3) {
      clearInterval(timer.value);
      timer.value = null;
      refreshCount.value = 0;
    }
  }, 30000);
};

if (checkSendStatus()) {
  startRefreshTimer();
}
onBeforeUnmount(() => {
  if (timer.value) {
    clearInterval(timer.value);
    timer.value = null;
  }
});

// 查看
const dialogShow = ref(false)
const merchantDialog = ref(false)
let row:RowI = reactive<RowI>({
    title: '',
    desc: '',
    msg_type: '',
    no_brand_ids:'',
    messageList:[]
})

const onRowClick = async(row,type) => {
    const { page, page_size } = infos;
    const params = {
        id: row.id,     
        page,      
        page_size     
    }; 
    const {code, data, msg} = await batchSendMsgsInfo(params) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    type === 1 ? dialogShow.value = true : merchantDialog.value = true
    data.batch_send.cat_ids = data.batch_send.cat_ids.split(',').map(Number)
    data.batch_send.no_brand_ids  = data.batch_send.no_brand_ids.split(',').map(Number).filter(item => item !== 0)
    infos.msginfo = data
    infos.total = data.batch_send_info.total
}   
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    infos.page_size = val
    getList()
}
const infoPageChange = (val) => {
    infos.page = val
    onRowClick(infos.msginfo.batch_send,2)
}
const infoSizeChange = (val) => {
    infos.page_size = val
    onRowClick(infos.msginfo.batch_send,2)
}
getList()
onGetBrandList()

onActivated(() => {
})

const exportMsgInfo = (id) => {   
    window.open(`${Keys.baseUrl}/admin/brands/export_batch_fail?${joinParams({id})}`);
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.send_status,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.send_status) = $event)),
        filterable: "",
        placeholder: "发送状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            value: 1,
            label: "发布成功"
          }),
          _createVNode(_component_el_option, {
            value: 2,
            label: "部分失败"
          }),
          _createVNode(_component_el_option, {
            value: 3,
            label: "发布失败"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.msg_type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.msg_type) = $event)),
        filterable: "",
        placeholder: "发送方式",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, { value: "" }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("全部")
            ])),
            _: 1
          }),
          _createVNode(_component_el_option, {
            value: 1,
            label: "邮件"
          }),
          _createVNode(_component_el_option, {
            value: 2,
            label: "短信"
          }),
          _createVNode(_component_el_option, {
            value: 3,
            label: "公众号"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "开始日期"
      }, null, 8, ["modelValue"]),
      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "结束日期"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/notice-admin/group-msg-edit')))
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [
          _createTextVNode("发通知")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: msgList.value,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "标题"
        }),
        _createVNode(_component_el_table_column, {
          prop: "msg_name",
          label: "发送方式"
        }),
        _createVNode(_component_el_table_column, {
          prop: "send_status",
          label: "发送状态"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", null, [
              (scope.row.send_status === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "发布成功"))
                : (scope.row.send_status === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "部分失败"))
                  : (scope.row.send_status === 3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "发布失败"))
                    : (scope.row.send_status === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "发送中"))
                      : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "发布时间",
          width: "160"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "260"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: ($event: any) => (onRowClick(scope.row,1))
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("查看内容")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: ($event: any) => (onRowClick(scope.row,2))
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("商家详情")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "通知详情",
      modelValue: dialogShow.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogShow).value = $event)),
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (dialogShow.value=false))
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (infos.msginfo.batch_send_task.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infos.msginfo.batch_send_task, (task, idx) => {
                return (_openBlock(), _createBlock(_component_el_button, {
                  key: 'btn-'+idx,
                  type: activeIndex.value === idx ? 'plain orange-but' : 'plain',
                  onClick: ($event: any) => (activeIndex.value = idx)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getButtonLabel(task.msg_type)), 1)
                  ]),
                  _: 2
                }, 1032, ["type", "onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infos.msginfo.batch_send_task, (row, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", { key: index }, [
            (row.msg_type === 2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "短信内容"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      modelValue: row.dx_desc,
                      "onUpdate:modelValue": ($event: any) => ((row.dx_desc) = $event),
                      disabled: "",
                      autosize: { minRows: 2 },
                      class: "auto-width-textarea"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024))
              : (row.msg_type === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_form_item, { label: "主题" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: row.email_title,
                          "onUpdate:modelValue": ($event: any) => ((row.email_title) = $event),
                          disabled: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "正文" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          modelValue: row.email_desc,
                          "onUpdate:modelValue": ($event: any) => ((row.email_desc) = $event),
                          disabled: "",
                          autosize: { minRows: 2 },
                          class: "auto-width-textarea"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "附件" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.attach_url, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_row, { key: idx }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_link, {
                                type: "primary",
                                href: item.url,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.file_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["href"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ], 64))
                : (row.msg_type === 3)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_el_form_item, { label: "标题" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            modelValue: row.title,
                            "onUpdate:modelValue": ($event: any) => ((row.title) = $event),
                            disabled: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "内容" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: row.desc,
                            "onUpdate:modelValue": ($event: any) => ((row.desc) = $event),
                            disabled: "",
                            autosize: { minRows: 2 },
                            class: "auto-width-textarea"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ], 64))
                  : _createCommentVNode("", true)
          ])), [
            [_vShow, activeIndex.value === index]
          ])
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "发送明细",
      modelValue: merchantDialog.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((merchantDialog).value = $event)),
      width: "700px",
      class: "merchantDialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (merchantDialog.value=false))
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode("关 闭")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "form bordered" }, {
          default: _withCtx(() => [
            (infos.msginfo.batch_send.type === 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "商家类型："
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: infos.msginfo.batch_send.cat_ids,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((infos.msginfo.batch_send.cat_ids) = $event)),
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, { label: 1 }, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createTextVNode("蛋糕")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_el_checkbox, { label: 5 }, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createTextVNode("零食")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_el_checkbox, { label: 8 }, {
                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                            _createTextVNode("鲜花")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_el_checkbox, { label: 4 }, {
                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createTextVNode("电子券")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (infos.msginfo.batch_send.type === 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "不发送品牌ID",
                  prop: "no_brand_ids "
                }, {
                  default: _withCtx(() => [
                    _createVNode(SelectBrand, {
                      multiple: true,
                      modelValue: infos.msginfo.batch_send.no_brand_ids ,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((infos.msginfo.batch_send.no_brand_ids ) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (infos.msginfo.batch_send.type === 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "不发送下架品牌品牌："
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(infos.msginfo.batch_send.is_status === 1?'是':'否'), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (infos.msginfo.batch_send.type === 2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 3,
                  label: "发送品牌",
                  prop: "brand_name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: infos.msginfo.batch_send.brand_name ,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((infos.msginfo.batch_send.brand_name ) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "发送失败统计如下：" }),
            _createVNode(_component_el_table, {
              data: infos.msginfo.batch_send_info.data,
              border: "",
              class: "merchantTable"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "id",
                  label: "品牌id"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "brand_name",
                  label: "商家"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "msg_type",
                  label: "发布方式"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", null, [
                      (scope.row.msg_type === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "邮件"))
                        : (scope.row.msg_type === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "短信"))
                          : (scope.row.msg_type === 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "公众号"))
                            : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "msg",
                  label: "发送失败"
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(Pagination, {
              size: "small",
              currentPage: infos.page,
              total: infos.total,
              onPageChange: infoPageChange,
              onSizeChange: infoSizeChange
            }, null, 8, ["currentPage", "total"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_link, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (exportMsgInfo(infos.msginfo.batch_send.id))),
          target: "_blank",
          style: {"float":"right","margin-top":"15px"}
        }, {
          default: _withCtx(() => _cache[25] || (_cache[25] = [
            _createTextVNode(" 导出发送失败记录 ")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})